import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Card, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { createSelector } from 'reselect'
import { setHeatmapData, setHeatmapFirstData, setHeatmapPage, setHeatmapTotalPage, toggleCreativeModal } from '../../slices/analytics/reducer';
import Preloader from '../../Components/Common/Preloader';
import { bytesToKB, scaleElementToFitParent } from '../../slices/helper';
import { createHeatmap, fillHeatmap } from '../../slices/analytics/thunk';
import simpleheat from 'simpleheat';
import BannerCard from '../Campaigns/Campaign/Components/BannerCard';

function CreativeModal() {
  const dispatch = useDispatch();
  const selectStates = createSelector(state => state, state => ({
    modalState: state.Analytics.creativeModal,
    creativePreview: state.Analytics.creativePreview,
    analyticsCampaigns: state.Analytics.analyticsCampaigns,
    heatmapLoader: state.Analytics.heatmapLoader,
    heatmapTotalPage: state.Analytics.heatmapTotalPage,
    heatmapPage: state.Analytics.heatmapPage,
    heatmapFirstData: state.Analytics.heatmapFirstData,
    heatmapData: state.Analytics.heatmapData
  }));
  const { modalState, creativePreview, analyticsCampaigns, heatmapLoader, heatmapTotalPage, heatmapPage, heatmapFirstData, heatmapData } = useSelector(selectStates);
  const [type, setType] = useState('');
  const [scalePercentage, setScalePercentage] = useState(100);
  const [currentCampaignState, setCurrentCampaignState] = useState(null);
  const previewCont = useRef();
  const heatmapCont = useRef();
  const heatmapBackdropCont = useRef();
  let heatmap;

  useEffect(() => {
    if (creativePreview) {
      const foundCampaign = analyticsCampaigns.find(item => item._id === creativePreview.campaignId);
      if (foundCampaign) {
        setCurrentCampaignState(foundCampaign);
        if (foundCampaign.bannerType === 'html' || foundCampaign.adType === 'social') {
          setType('html');
        } else {
          setType('image');
        }
      }
    }
  }, [analyticsCampaigns, creativePreview]);

  // useEffect(() => {
  //   if (creativePreview?.preview) {
  //     creativePreview.preview.style.display = 'block';
  //     creativePreview.preview.classList.add('preview');
  //     previewCont.current.appendChild(creativePreview.preview);
  //     setTimeout(() => {
  //       scaleElementToFitParent(previewCont.current?.children[0], setScalePercentage, 50);
  //     }, 1);
  //     window.addEventListener('resize', () => scaleElementToFitParent(previewCont.current?.children[0], setScalePercentage, 50));
  //   }

  //   if (previewCont.current !== null && previewCont.current !== undefined) {
  //     return () => {
  //       window.removeEventListener('resize', () => scaleElementToFitParent(previewCont.current?.children[0], setScalePercentage, 50));
  //     };
  //   }
  // }, [creativePreview, heatmapData]);

  // useEffect(() => {
  //   if (creativePreview?.path) {
  //     if (type === 'image') {
  //       scaleElementToFitParent(previewCont.current?.children[0], setScalePercentage, 50);
  //       window.addEventListener('resize', () => scaleElementToFitParent(previewCont.current?.children[0], setScalePercentage, 50));
  //     }
  //     return () => {
  //       window.removeEventListener('resize', () => scaleElementToFitParent(previewCont.current?.children[0], setScalePercentage, 50));
  //     };
  //   }
  // }, [creativePreview, heatmapData]);

  useEffect(() => {
    async function handleHeatmap() {
      if (heatmapFirstData) {
        const [width, height] = creativePreview.size.split('x')
        heatmapCont.current.style.width = `${width}px`;
        heatmapCont.current.style.height = `${height}px`;
        heatmapCont.current.width = width;
        heatmapCont.current.height = height;
        heatmapCont.current.style.position = 'absolute';
        heatmapCont.current.style.top = '50%';
        heatmapCont.current.style.left = '50%';
        heatmapCont.current.style.transformOrigin = 'center center';
        heatmapCont.current.style.zIndex = '3';
        heatmapBackdropCont.current.style.width = `${width}px`;
        heatmapBackdropCont.current.style.height = `${height}px`;
        let initData = [...heatmapFirstData];
        heatmap = simpleheat('heatmap').data(initData).radius(12, 12).max(100000);
        heatmap.draw(0.05);
        scaleElementToFitParent(heatmapCont.current, setScalePercentage, 50);
        scaleElementToFitParent(heatmapBackdropCont.current, setScalePercentage, 50);
        window.addEventListener('resize', () => scaleElementToFitParent(heatmapCont.current, setScalePercentage, 50));
        window.addEventListener('resize', () => scaleElementToFitParent(heatmapBackdropCont.current, setScalePercentage, 50));

        return () => {
          window.removeEventListener('resize', () => scaleElementToFitParent(heatmapCont.current, setScalePercentage, 50));
          window.removeEventListener('resize', () => scaleElementToFitParent(heatmapBackdropCont.current, setScalePercentage, 50));
        };
      }
    }
    handleHeatmap();
  }, [heatmapFirstData]);

  useEffect(() => {
    let isCancelled = false;

    async function handleHeatmapPage() {
      if (heatmapTotalPage > 0 && modalState) {
        let i = 1
        do {
          const data = await dispatch(fillHeatmap(i));
          if (data.length > 0) {
            let k = 0;
            do {
              heatmap.add([data[k][0], data[k][1], data[k][2]]);
              k++;
            } while (k < data.length);
            heatmap.draw(0.05);
          }
          if (isCancelled) {
            break;
          }
          i++;
        } while (i < heatmapTotalPage);
      }
    }
    handleHeatmapPage();

    return () => {
      isCancelled = true;
    };

  }, [heatmapTotalPage, modalState]);

  async function getHeatmap() {
    if (heatmapData) {
      dispatch(setHeatmapData(null));
      dispatch(setHeatmapFirstData(null));
      dispatch(setHeatmapTotalPage(0));
    } else {
      dispatch(createHeatmap());
    }
  }

  function closeModal() {
    dispatch(toggleCreativeModal());
    dispatch(setHeatmapData(null));
    dispatch(setHeatmapFirstData(null));
    dispatch(setHeatmapTotalPage(0));
  }

  return (
    <React.Fragment>
      <Modal isOpen={modalState} toggle={closeModal} centered size='md' className='analytics-showcase'>
        {/* <ModalBody className='p-0 d-flex flex-column align-items-center justify-content-center'>
        <div className='w-100 px-3 py-2 d-flex align-items-center justify-content-between border-bottom'>
          <p className='m-0'>{(creativePreview?.size || '')}</p>
          <button className={'btn px-2 py-1' + (heatmapFirstData ? ' btn-info' : ' btn-light')} onClick={getHeatmap}>
            <i className='ri ri-temp-cold-line'></i>
          </button>
        </div>
        <div className='w-100 d-flex align-items-center justify-content-center position-relative' style={{ minHeight: '400px', maxHeight: '400px' }}>
          {heatmapLoader ?
            <Preloader isComponentLoader={true} width={150} height={150} />
            : creativePreview && <React.Fragment>
              <div className='w-100 h-100 p-1 d-flex position-absolute' ref={previewCont}>
                {type === "html" ? null : <img className='preview' src={(creativePreview?.path || '')} onLoad={(e) => scaleElementToFitParent(e.target, setScalePercentage, 50)} draggable='false' />}
              </div> {heatmapFirstData ? <React.Fragment>
                <div className='heatmap-backdrop' ref={heatmapBackdropCont}></div>
                <canvas id='heatmap' ref={heatmapCont}></canvas>
              </React.Fragment> : null}
            </React.Fragment>

          }

        </div>
      </ModalBody>
      <ModalFooter>
        <button className='btn btn-light' onClick={closeModal}>Close</button>
      </ModalFooter> */}
        {creativePreview ?
          <React.Fragment>
            {currentCampaignState?.bannerType === 'html' ?
              <BannerCard
                id={creativePreview._id}
                figma={creativePreview.figma}
                type={'html'}
                size={creativePreview.size}
                showEdit={false}
                editableInFigmaPlugin={false}
                isCreativeCreated={true}
                updateStateAfterLoad={false}
                showHeatmap={true}
                heatmapFunc={getHeatmap}
              />
              :
              <BannerCard
                id={creativePreview._id}
                figma={creativePreview.figma}
                type={'image'}
                size={creativePreview.size}
                thumbnail={creativePreview?.path}
                showEdit={false}
                editableInFigmaPlugin={false}
                isCreativeCreated={true}
                updateStateAfterLoad={false}
                showHeatmap={true}
                heatmapFunc={getHeatmap}
              />}
            {heatmapFirstData ?
              <React.Fragment>
                <div className='heatmap-backdrop' ref={heatmapBackdropCont}></div>
                <canvas id='heatmap' ref={heatmapCont}></canvas>
              </React.Fragment> : null}
          </React.Fragment>
          : null}
      </Modal>
    </React.Fragment>


  )
}

export default CreativeModal
